import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import { CMDB_SOLUTIONS_URL, SOLUTIONS_URL } from 'src/constants/urls'

export const initialSolutionsState = {
    selectedCustomer: null,
    loading: false,
    status: null,
    solutionsMap: {},
    topSolutions: [],
}

export default createReducer(initialSolutionsState, {
    [actions.SET_SOLUTIONS_CUSTOMER]: (state, action) => ({
        ...state,
        status: null,
        selectedCustomer: action.payload.customerId,
    }),
    [actions.GET_CUSTOMER_SOLUTIONS]: (state) => ({
        ...state,
        loading: true,
    }),
    [actions.GET_CUSTOMER_SOLUTIONS_SUCCESS]: (state, action) => {
        return {
            ...state,
            loading: false,
            solutionsMap: action.payload.data.keys,
            topSolutions: action.payload.data.top,
            virps: action.payload.data.virps,
        }
    },
    [actions.STORE_CUSTOMER_SOLUTIONS]: (state) => {
        return { ...state, status: 'saving' }
    },
    [actions.STORE_CUSTOMER_SOLUTIONS_SUCCESS]: (state) => {
        return { ...state, status: 'success' }
    },
    [actions.STORE_CUSTOMER_SOLUTIONS_ERROR]: (state) => {
        return { ...state, status: 'error' }
    },
    [actions.CLEAR_SELECTED_CUSTOMER]: (state) => {
        return { ...state, selectedCustomer: null }
    },
})

export const selectCmdbSolutionCustomer = (customerId) => ({
    type: actions.SET_SOLUTIONS_CUSTOMER,
    payload: { customerId },
})

export const clearSelectedCustomer = () => ({
    type: actions.CLEAR_SELECTED_CUSTOMER,
})

export const fetchCmdbSolutions = (customerId) => ({
    type: actions.API,
    method: 'get',
    payload: {
        url: `${CMDB_SOLUTIONS_URL}${customerId}/`,
        start: () => ({ type: actions.GET_CUSTOMER_SOLUTIONS }),
        success: (payload) => ({
            type: actions.GET_CUSTOMER_SOLUTIONS_SUCCESS,
            payload,
            customerId,
        }),
        error: (error) => ({
            type: actions.GET_CUSTOMER_SOLUTIONS_ERROR,
            error,
        }),
    },
})

export const saveCmdbSolutions = (customerId) => (dispatch, getState) => {
    dispatch({
        type: actions.API,
        method: 'post',
        data: {
            keys: getState().cmdb.solutions.solutionsMap,
            top: getState().cmdb.solutions.topSolutions,
            virps: getState().cmdb.solutions.virps,
        },
        payload: {
            url: `${SOLUTIONS_URL}${customerId}/`,
            start: () => ({ type: actions.STORE_CUSTOMER_SOLUTIONS }),
            success: (payload) => ({
                type: actions.STORE_CUSTOMER_SOLUTIONS_SUCCESS,
                payload,
                customerId,
            }),
            error: (error) => ({
                type: actions.STORE_CUSTOMER_SOLUTIONS_ERROR,
                error,
            }),
        },
    })
}
